<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card>
          <v-data-table
            class="sortable"
            :headers="headers"
            :items="displayItems"
            disable-sort
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.uses="{ item }">
              <v-text-field
                :value="item.uses"
                type="number"
                name="uses"
                @change="updatePermissionUses(item, $event)"
                @keydown.native.enter.prevent
                :disabled="readOnly"
                reverse
              />
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import _ from 'lodash';

export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    plantUsers: {
      type: Array,
      default() {
        return [];
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: 'User', value: 'plantUser.name' },
        { text: 'Uses', value: 'uses', align: 'end' },
      ],
    };
  },
  computed: {
    displayItems() {
      return this.plantUsers.map((plantUser) => {
        const permission = _.find(this.items, { plantUser: { id: plantUser.id } });
        return permission || { plantUser, uses: 0 };
      });
    },
  },
  methods: {
    updatePermissionUses(item, value) {
      const duplicate = _.clone(this.items);
      const permission = _.find(duplicate, { id: item.id });
      if (permission) {
        permission.uses = value;
      } else {
        item.uses = value;
        duplicate.push(item);
      }
      this.$emit('update:items', duplicate);
    },
  },
};
</script>
